const locale = {
  ACCOUNT_MENU_BUTTON_ARIA_LABEL: 'Account menu, {{name}}',
  GUEST_NAME: 'Guest',
  CHANGE_PASSWORD: 'Change your password',
  LOGOUT: 'Logout',
  INSIGHT_PAGE_TITLE: 'Skill Insights',
  STUDENT_OVERVIEW_PAGE_TITLE: 'Student Overview',
  STUDENT_ADVISING_PAGE_TITLE: 'Student Advising',
  CAREER_TRENDS_PAGE_TITLE: 'Career Trends',
  CONTACT_US_PAGE_TITLE: 'Contact Us',
  FAQ_PAGE_TITLE: 'Frequently Asked Questions',
  ASIDE_ARIA_LABEL: 'Navigation sidebar',
  SKIP_TO_MAIN_CONTENT: 'Skip to main content',
};

export default locale;
